function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#25AFF4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20.533 10.553c-.344.524-.76.97-1.247 1.339a7.643 7.643 0 01-.285 2.418 7.648 7.648 0 01-.889 1.993 7.738 7.738 0 01-1.42 1.689c-.55.49-1.212.88-1.987 1.17a6.994 6.994 0 01-2.486.438A6.71 6.71 0 018.4 18.437c.18.021.38.032.6.032a4.748 4.748 0 003.088-1.107 2.359 2.359 0 01-1.448-.517 2.527 2.527 0 01-.877-1.28c.17.027.326.04.47.04.22 0 .438-.029.654-.088a2.426 2.426 0 01-1.428-.894 2.564 2.564 0 01-.566-1.648v-.032c.349.203.723.313 1.124.329a2.564 2.564 0 01-.809-.923c-.2-.38-.3-.791-.3-1.235 0-.47.113-.906.339-1.307a7.122 7.122 0 002.267 1.913c.89.478 1.844.744 2.86.798a3.08 3.08 0 01-.061-.594c0-.716.242-1.327.727-1.833a2.352 2.352 0 011.76-.758c.718 0 1.324.273 1.816.818a4.748 4.748 0 001.579-.625 2.505 2.505 0 01-1.094 1.428 4.805 4.805 0 001.432-.402z"
}));

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _ref);
}

export default SvgTwitter;